@if ((laudatio$ | async); as laudatio) {
  <div class="accordeon-tab">
    <input type="checkbox" id="laudatio-toggle" class="acordeon">
    <label class="accordeon-tab-label" for="laudatio-toggle"><h2>{{laudatio.data.attributes.title | uppercase}}</h2></label>
    <div class="accordeon-tab-content">
      <span [innerHtml]="laudatio.data.attributes.text"></span><br>
    </div>
  </div>
}